import { render, staticRenderFns } from "./WysiwygQuestion.vue?vue&type=template&id=15d5f92e"
import script from "./WysiwygQuestion.vue?vue&type=script&lang=js"
export * from "./WysiwygQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports